import React from "react";
import "./mvv.css"
import { useInView } from "react-intersection-observer";
import { Icon } from "@mui/material";

function Mvv() {
    const {ref:labelMVV, inView:labelIsVisible} = useInView({
        "threshold":.90,
        "fallbackInView":true
    })
    const {ref:iconosMVV, inView:IconIsVisible} = useInView({
        "threshold":.50,
        "fallbackInView":true
    })
    return (
       
            <div className="item-content">
                <div className="ni-content">
                    <div className="ni-content-img">
                        <img ref={iconosMVV} className={`misionImage ${IconIsVisible ? "misionImageAnimation" : ""}`} src="./Images/mision.png" alt="mision" />
                    </div>
                    <div className="ni-title">
                        <h3 ref={labelMVV} className={`MVVText ${labelIsVisible ? "MVVTextAnimation" : ""}`}>MISION</h3>
                        <h4 ref={labelMVV} className={`MVVText ${labelIsVisible ? "MVVTextAnimation" : ""}`}>
                            Lorem ipsum dolor sit amet consectetur <br /> adipisicing elit.
                            Ipsa, quibusdam.
                        </h4>
                    </div>
                </div>

                <div className="ni-content">
                    <div className="ni-content-img">
                        <img className={`misionImage ${IconIsVisible ? "misionImageAnimation" : ""}`} src="./Images/vision.png" alt="mision" />
                    </div>
                    <div className="ni-title">
                        <h3 ref={labelMVV} className={`MVVText ${labelIsVisible ? "MVVTextAnimation" : ""}`}>VISION</h3>
                        <h4 ref={labelMVV} className={`MVVText ${labelIsVisible ? "MVVTextAnimation" : ""}`}>
                            Lorem ipsum dolor sit amet consectetur <br /> adipisicing elit.
                            Ipsa, quibusdam.
                        </h4>
                    </div>
                </div>

                <div className="ni-content">
                    <div className="ni-content-img">
                        <img className={`misionImage ${IconIsVisible ? "misionImageAnimation" : ""}`} src="./Images/valor.png" alt="mision" />
                    </div>
                    <div className="ni-title">
                        <h3 ref={labelMVV} className={`MVVText ${labelIsVisible ? "MVVTextAnimation" : ""}`}>VALORES</h3>
                        <h4 ref={labelMVV} className={`MVVText ${labelIsVisible ? "MVVTextAnimation" : ""}`}>
                            Lorem ipsum dolor sit amet consectetur <br /> adipisicing elit.
                            Ipsa, quibusdam.
                        </h4>
                    </div>
                </div>
            </div>
        
    )
}

export default Mvv;